import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import { useAuth } from '@contexts/Auth'
// import BecomeAuthorIllustration from '@public/static/vectorIllustrations/becomeAuthorIllustration'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import AnimatedNumber from './AnimatedNumber'
import LearnHowWeEstimatePopUp from './HowWeEstimatePopUp'
import SetEstimatesPopUp from './TotalEstimatePopUp'
import AuthorDetailsModal from './AuthorDetailsModal'
import {
  Button,
  Input,
  ModalBody,
  ModalContent,
  ModalHeader,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Slider,
  Switch,
  useDisclosure,
} from '@nextui-org/react-latest'
import { Modal as NextModal } from '@nextui-org/react-latest'
import EmailIcon from '@public/static/icons/email-icon'
import TwitterIcon from '@public/static/icons/twitter-icon'
import LinkIcon from '@public/static/icons/link-icon'
import FaceBookIcon from '@public/static/icons/facebook-icon'
import LinkedInIcon from '@public/static/icons/linkedin-icon'
import TelegramIcon from '@public/static/icons/telegram-icon'
import KeyBenefits from './KeyBenefits'
import HowItWorks from './KeyBenefits/HowItWorks'
import JoinUs from './KeyBenefits/JoinUs'
import ConnectWithUs from '../benefits/ConnectWIthUs'
import Explore from '../advantageous/Explore'
import createEstimateURL from '@services/api/user/estimates/createEstimate'
import useWindowDimensions from '@hooks/useWindowDimensions'

type BecomeAuthorProps = {}

const BecomeAuthorWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  color: ${colors.uguPurple};
  align-self: center;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  @media (min-width: 1300px) {
    width: 1250px;
  }
`

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  align-items: center;
  @media (min-width: 768px) {
    width: 50%;
    padding: 10rem 2rem 1rem 2rem;
  }
  @media (min-width: 992px) {
    padding: 10rem 3rem 1rem 3rem;
  }
  @media (min-width: 1300px) {
    padding: 10rem 4rem 1rem 4rem;
  }
`
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 1rem;
  font-size: 2rem;
  line-height: 2.25rem;
  font-family: ${fontFamilies.semiBold};
  width: 100%;
  @media (min-width: 768px) {
    font-size: 2.5rem;
    line-height: 2.75rem;
  }
  @media (min-width: 992px) {
    font-size: 3rem;
    line-height: 3.25rem;
  }
`
const PriceLabel = styled.div`
  font-size: 3rem;
  font-family: ${fontFamilies.semiBold};
  margin-top: 1rem;
  max-width: 100%;
  overflow: hidden;
  @media (min-width: 768px) {
    font-size: 3.5rem;
  }
  @media (min-width: 992px) {
    font-size: 4.5rem;
  }
`
const AvarageEstimationWrapper = styled.span`
  /* display: flex; */
  font-size: 0.875rem;
  width: 18rem;
  font-family: ${fontFamilies.semiBold};
  text-align: center;
  margin-top: 1rem;
  padding: 0 0.5rem;
  @media (min-width: 768px) {
    font-size: 0.9rem;
  }
  @media (min-width: 992px) {
    font-size: 1rem;
  }
`

const StudentQty = styled.span`
  text-decoration: underline;
  margin-right: 0.25rem;
  :hover {
    cursor: pointer;
  }
`

const SliderWrapper = styled.div`
  display: flex;
  height: 1rem;
  width: 18rem;
  align-items: center;
  margin-top: 1rem;
`

const LearnHowWeEstimate = styled.div`
  display: flex;
  margin-top: 1rem;
  margin-bottom: 24px;
  font-family: ${fontFamilies.light};
  text-decoration: underline;
  font-size: 0.875rem;
  @media (min-width: 768px) {
    font-size: 0.9rem;
  }
  @media (min-width: 992px) {
    font-size: 1rem;
  }
  :hover {
    cursor: pointer;
  }
`
const BecomeAuthorButtonWrapper = styled.div`
  display: flex;
  border: 1px solid ${colors.uguPurple};
  font-family: ${fontFamilies.semiBold};
  font-size: 1rem;
  /* margin-top: 2rem; */
  border-radius: 10px;
  padding: 0.75rem 4.5rem;
  :hover {
    cursor: pointer;
  }
`

const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 768px) {
    padding: 0 2rem 1rem 2rem;
    width: 50%;
  }
  @media (min-width: 992px) {
    padding: 0 3rem 1rem 3rem;
  }
  @media (min-width: 1300px) {
    padding: 0rem 4rem 1rem 4rem;
  }
`
// const IllustrationWrapper = styled.div`
//   display: none;
//   width: 100%;
//   @media (min-width: 768px) {
//     display: flex;
//     margin-top: -2rem;
//   }
// `
const ExploreEdugramWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

// const ExloreEdugramMessageWrapper = styled.div`
//   display: flex;
//   font-size: 1rem;
//   justify-content: center;
//   @media (min-width: 768px) {
//     font-size: 1.15rem;
//   }
//   @media (min-width: 992px) {
//     font-size: 1.25rem;
//   }
// `
// const ExploreEdugramButtonWrapper = styled.div`
//   display: flex;
//   width: 18rem;
//   justify-content: center;
//   border: 1px solid;
//   background-color: ${colors.uguBrightPurple};
//   margin-top: 1rem;
//   font-family: ${fontFamilies.semiBold};
//   font-size: 1rem;
//   border-radius: 10px;
//   padding: 0.75rem;
//   color: white;
//   :hover {
//     cursor: pointer;
//   }
// `

const AlreadyAnAuthor = styled.div`
  margin-bottom: 16px;
  text-align: center;
  font-family: ${fontFamilies.semiBold};
  font-size: 1rem;
`

const formatNumber = (num: number): string => {
  const formatted = num.toLocaleString('en-US')
  return formatted
}

const AVARAGE_COURSE_PRICE = 49.99
const AVARAGE_FEE = 0.75
const STUDENTS_STEPS = [100, 200, 300, 500, 750, 1000, 1250, 2000, 5000, 7500]

const calculatePriceUsingSlider = (
  value: number,
  price: number = AVARAGE_COURSE_PRICE
): number => {
  let index = Math.floor(value / 10)
  if (index > 9) index = 9 // if value is 100, index should be 9
  return Math.floor(value * price * STUDENTS_STEPS[index] * AVARAGE_FEE)
}

const calculatePriceUsingCalculator = (students, price) => {
  return Math.floor(price * students * AVARAGE_FEE)
}

const calculateStudents = (value: number): number => {
  let index = Math.floor(value / 10)
  if (index > 9) index = 9 // if value is 100, index should be 9
  return Math.floor(value * STUDENTS_STEPS[index])
}

const deriveValueFromStudents = (studentQty: number): number => {
  for (let i = 0; i < STUDENTS_STEPS.length; i++) {
    if (studentQty < STUDENTS_STEPS[i] * 9 + STUDENTS_STEPS[i] * i * 10) {
      return Math.min(Math.floor(studentQty / STUDENTS_STEPS[i]), 100)
    }
  }
  return Math.min(
    Math.floor(studentQty / STUDENTS_STEPS[STUDENTS_STEPS.length - 1]),
    100
  )
}

const DEFAULT_SLIDER_VALUE = 15
const DEFAULT_STUDENT_AMOUNT = 3000

const calculateDefaultTotalEarning = (students: number, price: number) => {
  return Math.floor(students * price * AVARAGE_FEE)
}

type EarningEstimateStateType = {
  sliderValue: number
  students: number
  pricePerCourse: number
  totalEarnings: number
}

const BecomeAuthor: React.FC<BecomeAuthorProps> = () => {
  const router = useRouter()
  const priceFromURL = Number(router.query.price)
  const studentsFromURL = Number(router.query.students)
  const { user, isAuthLoading, isAuthenticated, setShowAuthModal } = useAuth()
  const [showBecomeAuthorModal, setShowBecomeAuthorModal] =
    useState<boolean>(false)
  const { isOpen, onOpenChange, onOpen } = useDisclosure()
  const {
    isOpen: estimationIsOpen,
    onOpenChange: estimationOnOpenChange,
    onOpen: estimationOnOpen,
    onClose: estimatiomClose,
  } = useDisclosure()

  const [state, setState] = useState<EarningEstimateStateType>({
    sliderValue: studentsFromURL
      ? deriveValueFromStudents(studentsFromURL)
      : DEFAULT_SLIDER_VALUE,
    students: studentsFromURL || DEFAULT_STUDENT_AMOUNT,
    pricePerCourse: priceFromURL || AVARAGE_COURSE_PRICE,
    totalEarnings: calculateDefaultTotalEarning(
      studentsFromURL || DEFAULT_STUDENT_AMOUNT,
      priceFromURL || AVARAGE_COURSE_PRICE
    ),
  })
  const { t } = useTranslation(['aboutAuthor'])
  const [showModalType, setShowModalType] = useState<
    'howWeEstimate' | 'totalEstimate' | 'hidden'
  >('hidden')

  const [isPersonalized, setIsPersonalized] = useState(false)
  const [personalizedURL, setPersonalizedURL] = useState<string>('')
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
  })
  const [isGenerating, setIsGenerating] = useState<boolean>(false)
  const [isPopover, setIsPopover] = useState<boolean>(false)
  const { width } = useWindowDimensions()

  const addSelectionToUrl = (students: number, price: number) => {
    router.push(
      {
        pathname: router.pathname,
        query: { price, students },
      },
      undefined,
      { shallow: true }
    )
  }

  useEffect(() => {
    if (router.query?.b === 'true' && user && !user?.isAuthor) {
      setShowBecomeAuthorModal(true)
    }
  }, [router?.query?.b, user])

  const applyEstimates = (students: number, price: number) => {
    const newValue = deriveValueFromStudents(students)
    setState({
      ...state,
      sliderValue: newValue,
      totalEarnings: calculatePriceUsingCalculator(students, price),
      students: students,
      pricePerCourse: price,
    })
    addSelectionToUrl(students, price)

    estimatiomClose()
  }

  const onSliderChange = (newValue: number) => {
    const newStudents = calculateStudents(newValue)
    setState({
      ...state,
      sliderValue: newValue as number,
      totalEarnings: calculatePriceUsingSlider(newValue, state.pricePerCourse),
      students: newStudents,
    })

    addSelectionToUrl(newStudents, state.pricePerCourse)
  }

  // const navigateToLandingPage = () => {
  //   router.push('/benefits')
  // }

  // const becomeAuthorAction = async () => {
  // updateProfileInfo({ isAuthor: true })
  //   .then((updatedUser) => {
  //     updateCurrentUserFromResponse(updatedUser)
  //   })
  //   .catch((err) => console.error('becomeAuthor Action has been failed', err))
  // }

  const becomeAuthorButtonClicked = async () => {
    if (isAuthenticated) {
      setShowBecomeAuthorModal(true)
    } else {
      setShowAuthModal(true)
    }
  }

  const handleCreateURL = async () => {
    if (
      formData.first_name.length < 3 ||
      formData.last_name.length < 3 ||
      personalizedURL
    )
      return
    setIsGenerating(true)
    try {
      const value = `${formData.first_name.toLowerCase()}-${formData.last_name.toLowerCase()}`
      const res = await createEstimateURL({
        first_name: formData.first_name,
        last_name: formData.last_name,
        price: state.pricePerCourse * 100,
        students: state.students,
        value,
      })
      if (res) {
        const baseURL =
          window.location.href.split('/')[0] +
          '//' +
          window.location.href.split('/')[2]
        const url = `${baseURL}/invite/${res.value}`
        setPersonalizedURL(url)
      }
    } catch (error) {
    } finally {
      setIsGenerating(false)
    }
  }

  const shareURL =
    isPersonalized && personalizedURL
      ? personalizedURL
      : typeof window !== 'undefined'
        ? window.location.href
        : ''
  const shareText = t('becomeAuthorOnEdugram', { ns: 'aboutAuthor' })

  return (
    <div className="max-w-full flex flex-col">
      <BecomeAuthorWrapper>
        <LeftWrapper>
          <TitleWrapper>
            <span
              style={{
                color: colors.uguBrightPurple,
              }}
            >
              {t('edugramIt', { ns: 'aboutAuthor' })}{' '}
            </span>

            {t('youCouldEarn', { ns: 'aboutAuthor' })}
          </TitleWrapper>
          <PriceLabel>
            <AnimatedNumber value={state.totalEarnings} />
          </PriceLabel>
          <AvarageEstimationWrapper>
            <StudentQty
              onClick={() => {
                estimationOnOpen()
                setShowModalType('totalEstimate')
              }}
            >
              {formatNumber(state.students)}{' '}
              {t('studentsLowerCase', { ns: 'aboutAuthor' })}
            </StudentQty>
            {t('withAnAvaragePrice', { ns: 'aboutAuthor' })}
            {formatNumber(Number(state.pricePerCourse.toFixed(2)))}{' '}
            {t('usdPerCourse', { ns: 'aboutAuthor' })}
          </AvarageEstimationWrapper>
          <SliderWrapper>
            <Slider
              step={1}
              minValue={1}
              defaultValue={60}
              value={state.sliderValue}
              onChange={(newValue) => {
                setState({ ...state, sliderValue: newValue as number })
                onSliderChange(newValue as number)
              }}
              size="md"
              color="secondary"
              className="max-w-md"
              renderThumb={(props) => (
                <div
                  {...props}
                  className="group top-1/2 rounded-full cursor-grab data-[dragging=true]:cursor-grabbing"
                >
                  <span className="transition-transform bg-uguPurple rounded-full w-5 h-5 block group-data-[dragging=true]:scale-80" />
                </div>
              )}
              classNames={{
                track: 'h-1.5',
              }}
            />
          </SliderWrapper>
          <LearnHowWeEstimate
            onClick={() => {
              estimationOnOpen()
              setShowModalType('howWeEstimate')
            }}
          >
            {t('learnHowWeEstimate', { ns: 'aboutAuthor' })}
          </LearnHowWeEstimate>
          {/* {!isAuthLoading &&
            (!isAuthenticated || (isAuthenticated && !user?.isAuthor)) && (
              <BecomeAuthorButtonWrapper
                onClick={() => {
                  becomeAuthorButtonClicked()
                }}
              >
                
                {t('becomeAuthor', { ns: 'aboutAuthor' })}
              </BecomeAuthorButtonWrapper>
            )} */}
          {!isAuthLoading &&
            (!isAuthenticated || (isAuthenticated && !user?.isAuthor)) && (
              <Button
                onClick={() => {
                  becomeAuthorButtonClicked()
                }}
                className="h-[53px] w-[283px] font-semiBold"
                color="primary"
              >
                {t('becomeAuthor', { ns: 'aboutAuthor' })}
              </Button>
            )}
          {!isAuthLoading && isAuthenticated && user?.isAuthor && (
            <div>
              <AlreadyAnAuthor>
                {t('alreadyAnAuthor', { ns: 'aboutAuthor' })}
              </AlreadyAnAuthor>
              <BecomeAuthorButtonWrapper
                onClick={() => {
                  router.push('/author')
                }}
              >
                {t('authorDashboard', { ns: 'aboutAuthor' })}
              </BecomeAuthorButtonWrapper>
            </div>
          )}
          <button className="mt-4 font-light underline" onClick={onOpen}>
            {t('shareEstimates', { ns: 'aboutAuthor' })}
          </button>
        </LeftWrapper>
        <RightWrapper>
          {/* <IllustrationWrapper>
            <BecomeAuthorIllustration width={'100%'} />
          </IllustrationWrapper> */}
          <iframe
            // width="1521"
            // height="561"
            className="w-full aspect-video m-auto"
            src="https://www.youtube.com/embed/nYjFa99kv6E"
            title="What is Edugram?"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
          <ExploreEdugramWrapper>
            {/* <div className="flex items-center gap-2 cursor-pointer">
              <span>
                <MyCourseIcon height="1.2rem" />
              </span>
              <span className="underline text-uguPurple font-semiBold decoration-1">
                {t('whatIsEdugram', { ns: 'aboutAuthor' })}
                <span className="font-light">(01:24)</span>
              </span>
            </div> */}
            {/* <ExloreEdugramMessageWrapper>
              {t('interestedInWhatWeOffer', { ns: 'aboutAuthor' })}
            </ExloreEdugramMessageWrapper>
            <ExploreEdugramButtonWrapper
              onClick={() => navigateToLandingPage()}
            >
              {t('exploreEdugramBenefits', { ns: 'aboutAuthor' })}
            </ExploreEdugramButtonWrapper> */}
          </ExploreEdugramWrapper>
        </RightWrapper>
      </BecomeAuthorWrapper>
      <div className="mx-auto max-w-7xl flex flex-col gap-20 mt-[12rem]">
        <KeyBenefits />
        <HowItWorks />
        <JoinUs />
        <Explore />
        <ConnectWithUs isBecomeAuthor={true} />
      </div>
      <AuthorDetailsModal
        isOpen={showBecomeAuthorModal}
        onClose={(ask?: boolean) => {
          if (ask) {
            if (confirm('Are you sure you want to close?')) {
              setShowBecomeAuthorModal((prev) => !prev)
            }
          } else {
            setShowBecomeAuthorModal((prev) => !prev)
          }
        }}
      />
      <NextModal
        size="xl"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        onClose={() => {
          setPersonalizedURL('')
          setFormData({ first_name: '', last_name: '' })
        }}
        scrollBehavior={(width || 0) <= 640 ? 'inside' : 'outside'}
        classNames={{
          closeButton:
            'mt-2 mr-2 bg-white rounded-full sm:shadow-none shadow z-10',
        }}
        placement={(width || 0) <= 640 ? 'bottom' : 'center'}
      >
        <ModalContent
          className={`${
            (width || 0) <= 640
              ? 'w-full m-0 max-w-full !mx-0 !my-0 rounded-b-none'
              : ''
          }`}
        >
          <ModalHeader className="font-semiBold text-2xl text-uguPurple">
            {t('shareEstimates', { ns: 'aboutAuthor' })}
          </ModalHeader>
          <ModalBody>
            <div>
              <div className="flex items-center gap-2">
                <Switch
                  onValueChange={(e) => setIsPersonalized(e)}
                  isSelected={isPersonalized}
                  size="md"
                />
                <span className="font-medium !tracking-normal">
                  {t('personalizedShare', { ns: 'aboutAuthor' })}
                </span>
              </div>
            </div>
            {isPersonalized && (
              <div className="flex gap-3 sm:gap-0.5 items-center w-full mt-4 sm:flex-row flex-col flex-wrap sm:border border-slate-200 rounded-full p-1">
                <Input
                  className="font-regular flex-1 bg-white rounded-full"
                  classNames={{
                    input:
                      'placeholder:text-uguPurple text-[16px] max-w-max text-sm  font-openSansRegular',
                    inputWrapper:
                      '!shadow-none !border !border-slate-100  bg-slate-50',
                  }}
                  placeholder={t('firstName', { ns: 'aboutAuthor' })}
                  size="lg"
                  value={formData.first_name}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      first_name: e.target.value,
                    }))
                  }
                  isDisabled={personalizedURL ? true : false}
                  radius="full"
                  variant="bordered"
                  maxLength={27}
                />
                <Input
                  className="font-regular flex-1 bg-white rounded-full"
                  classNames={{
                    input:
                      'placeholder:text-uguPurple text-[16px] max-w-max text-sm font-openSansRegular',
                    inputWrapper:
                      ' !shadow-none !border !border-slate-100 bg-slate-50',
                  }}
                  placeholder={t('lastName', { ns: 'aboutAuthor' })}
                  variant="bordered"
                  size="lg"
                  value={formData.last_name}
                  maxLength={27}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      last_name: e.target.value,
                    }))
                  }
                  radius="full"
                  isDisabled={personalizedURL ? true : false}
                />
                <Button
                  color="primary"
                  className="h-[46px] tracking-normal font-openSansRegular"
                  onPress={handleCreateURL}
                  isDisabled={isGenerating}
                  isLoading={isGenerating}
                  radius="full"
                >
                  {t('generateLink', { ns: 'aboutAuthor' })}
                </Button>
              </div>
            )}
            {personalizedURL && isPersonalized && (
              <div className="flex mx-auto mt-4 bg-slate-200 bg-opacity-60 text-sm font-openSansRegular p-2 px-3 rounded-full">
                {personalizedURL}
              </div>
            )}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 my-5">
              <Popover
                isOpen={isPopover}
                onOpenChange={() => {
                  setIsPopover(true)
                  navigator.clipboard.writeText(shareURL)
                  setTimeout(() => {
                    setIsPopover(false)
                  }, 2000)
                }}
                placement={'top'}
              >
                <PopoverTrigger>
                  <div className="col-span-1 flex gap-5 h-14 rounded-xl border border-gray-200 items-center px-6 cursor-pointer active:bg-gray-100 transition-all duration-100">
                    <span className="max-w-max">
                      <LinkIcon height="1.3rem" width="1.3rem" />
                    </span>
                    <span className="font-semiBold !tracking-normal">
                      {t('copyLink', { ns: 'aboutAuthor' })}
                    </span>
                  </div>
                </PopoverTrigger>
                <PopoverContent>
                  <span className="font-regular">
                    {t('linkCopied', { ns: 'aboutAuthor' })}
                  </span>
                </PopoverContent>
              </Popover>

              <div
                onClick={() => {
                  window.open(`mailto:?subject=${shareText}&body=${shareURL}`)
                }}
                className="col-span-1 flex gap-5 h-14 rounded-xl border border-gray-200 items-center px-6 cursor-pointer active:bg-gray-100 transition-all duration-100"
              >
                <span className="max-w-max">
                  <EmailIcon height="1.2rem" width="1.6rem" />
                </span>
                <span className="font-semiBold !tracking-normal">
                  {t('email', { ns: 'aboutAuthor' })}
                </span>
              </div>
              <div
                onClick={() => {
                  window.open(
                    `https://twitter.com/intent/tweet?text=${shareText} %0A%0ALink: ${window.location.href}`
                  )
                }}
                className="col-span-1 flex gap-5 h-14 rounded-xl border border-gray-200 items-center px-6 cursor-pointer active:bg-gray-100 transition-all duration-100"
              >
                <span className="max-w-max">
                  <TwitterIcon height="1.2rem" width="1.3rem" />
                </span>
                <span className="font-semiBold !tracking-normal">
                  {t('twitter', { ns: 'aboutAuthor' })}
                </span>
              </div>
              <div
                onClick={() => {
                  window.open(
                    `https://www.facebook.com/sharer.php?u=${shareURL}`
                  )
                }}
                className="col-span-1 flex gap-5 h-14 rounded-xl border border-gray-200 items-center px-6 cursor-pointer active:bg-gray-100 transition-all duration-100"
              >
                <span className="max-w-max">
                  <FaceBookIcon height="1.3rem" width="1.3rem" />
                </span>
                <span className="font-semiBold !tracking-normal">
                  {t('facebook', { ns: 'aboutAuthor' })}
                </span>
              </div>
              <div
                onClick={() => {
                  window.open(
                    `http://www.linkedin.com/shareArticle?mini=true&url=${shareURL}`
                  )
                }}
                className="col-span-1 flex gap-5 h-14 rounded-xl border border-gray-200 items-center px-6 cursor-pointer active:bg-gray-100 transition-all duration-100"
              >
                <span className="max-w-max">
                  <LinkedInIcon height="1.3rem" width="1.3rem" />
                </span>
                <span className="font-semiBold !tracking-normal">
                  {t('linkedin', { ns: 'aboutAuthor' })}
                </span>
              </div>
              <div
                onClick={() => {
                  window.open(
                    `https://telegram.me/share/url?url=${shareURL}&text=${shareText}`
                  )
                }}
                className="col-span-1 flex gap-5 h-14 rounded-xl border border-gray-200 items-center px-6 cursor-pointer active:bg-gray-100 transition-all duration-100"
              >
                <span className="max-w-max">
                  <TelegramIcon height="1.3rem" width="1.3rem" />
                </span>
                <span className="font-semiBold !tracking-normal">
                  {t('telegram', { ns: 'aboutAuthor' })}
                </span>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </NextModal>
      <NextModal
        isOpen={estimationIsOpen}
        onOpenChange={estimationOnOpenChange}
        hideCloseButton
        scrollBehavior={(width || 0) <= 640 ? 'inside' : 'outside'}
        classNames={{
          closeButton:
            'mt-2 mr-2 bg-white rounded-full sm:shadow-none shadow z-10',
        }}
        placement={(width || 0) <= 640 ? 'bottom' : 'center'}
      >
        <ModalContent
          className={`${
            (width || 0) <= 640
              ? 'w-full m-0 max-w-full !mx-0 !my-0 rounded-b-none'
              : ''
          }`}
        >
          <ModalBody>
            {showModalType === 'totalEstimate' && (
              <SetEstimatesPopUp
                price={state.pricePerCourse}
                students={state.students}
                onApply={applyEstimates}
                onClose={() => {
                  estimatiomClose()
                  setTimeout(() => {
                    setShowModalType('hidden')
                  }, 500)
                }}
              />
            )}
            {showModalType === 'howWeEstimate' && (
              <LearnHowWeEstimatePopUp
                onClose={() => {
                  estimatiomClose()
                  setTimeout(() => {
                    setShowModalType('hidden')
                  }, 500)
                }}
              />
            )}
          </ModalBody>
        </ModalContent>
      </NextModal>
    </div>
  )
}
export default BecomeAuthor
